/* eslint-disable arrow-body-style */
import http from "./utils";
import { overviewOriginType } from '@/pages/opinion/types/performance';
import { prefix, intelligencePrefix } from './constants';

export const getDetailBasicInfo: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${intelligencePrefix}/detail/basic_info`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};
